firebird.directive('hideListOnEmpty', [
    '$rootScope',
    'logService',
    function ($rootScope, logService) {
        const logger = new LogServiceWrapper(logService, 'hideListOnEmpty');

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var list = element.find('.dropdown-menu .listview .lv-body');

                scope.$watch(
                    function () {
                        return list.html();
                    },
                    function (val) {
                        var children = list.find('> div');
                        var visibleCount = 0;

                        try {
                            for (var i = 0; i < children.length; i++) {
                                if (!angular.element(children[i]).hasClass('ng-hide')) {
                                    visibleCount++;
                                    break;
                                }
                            }
                        } catch (e) {
                            logger.error('directive', 'Unable to parse dropdown list for item count', e);

                            //Keep element visible by default
                            visibleCount++;
                        }

                        if (visibleCount > 0) {
                            element.removeClass('dropdown-hide');
                        } else {
                            element.addClass('dropdown-hide');
                        }
                    }
                );
            }
        };
    }
]);
